/**
 * Rights Admin API Client
 */

const API_BASE = import.meta.env.DEV
    ? 'http://localhost:8787'
    : 'https://api.tattlehash.com';

export async function adminApi(path: string, options: RequestInit = {}) {
    const token = localStorage.getItem('admin_secret') || '';
    try {
        const resp = await fetch(API_BASE + path, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                'x-admin-secret': token,
                ...options.headers,
            },
        });
        if (!resp.ok) return { ok: false, status: resp.status, data: null };
        const data = await resp.json();
        return { ok: true, status: resp.status, data };
    } catch {
        return { ok: false, status: 0, data: null };
    }
}

export function adminGet(path: string) { return adminApi(path); }
export function adminPost(path: string, body?: unknown) {
    return adminApi(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined });
}
export function adminPut(path: string, body: unknown) {
    return adminApi(path, { method: 'PUT', body: JSON.stringify(body) });
}
